import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeClaimReasonList } from './normalize';

export const fetchClaimReasonList = createProvider(api.fetchClaimReasonList)
  .andThen((res) => normalizeClaimReasonList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch claim reason list aborted');
    } else {
      console.error('Fetch claim reason list was failed:', error);
    }
    throw error;
  });
